import { createSelector } from 'reselect';
import * as VerifyGetters from '../operators/verifyFbmInstallGetters';
export const getRequestStatus = createSelector(VerifyGetters.getVerifyFbmInstall, VerifyGetters.getRequestStatus);
export const getConfig = createSelector(VerifyGetters.getVerifyFbmInstall, VerifyGetters.getConfig);
export const getPageName = createSelector(getConfig, VerifyGetters.getPageName);
export const getPageLink = createSelector(getConfig, VerifyGetters.getPageLink);